import axios from '@/axios';
import router from '@/router';
import {dev} from '@/api/url';

const baseUrl = dev;
const headers = {
  'Content-type': 'application/json',
};

const config = {
  timeout: 30000,
  method: null,
  emulateJSON: true,
  url: '',
  headers,
  data: null,
};

export default {
  getSkillSheet: (authUserId, sessionKey, staffId) => {
    config.url = baseUrl + '/api/skillSheet/get';
    config.method = 'POST';
    config.data = { authInfo: { authUserId, sessionKey }, staffId };

    return axios.request(config)
      .then((res) => {
        if (res.data) {
          return res.data; // data配列を返す
        } else {
          throw new Error(res.data.message || 'エラーが起きた');
        }
      })
      .catch((err) => {
       console.log("err: ", err);
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.message || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
          const error = new Error(errorMessage);
          error.status = err.response.status;
          throw error;
        } else {
          errorMessage = err.message;
          throw new Error(errorMessage);
        }
      });
  },
  editSkillSheet: async (authUserId, sessionKey, userName, careerData, careerItemsData, skillSheetData) => {
    config.url = baseUrl + '/api/skillSheet/update';
    config.method = 'POST';
    config.data = { authInfo: { authUserId, sessionKey }, userName, careerData, careerItemsData, skillSheetData };

    return axios.request(config)
      .then((res) => {
        return res
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },
  deleteAllSkillSheets: async (authUserId, sessionKey, staffId) => {
  const config = {};
  config.url = baseUrl + '/api/skillSheet/all';
  config.method = 'POST';
  config.data = {
    authInfo: { authUserId, sessionKey },
    staffId,
  };

  return axios.request(config)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      let errorMessage = '';
      if (err.code === 'ERR_NETWORK') {
        errorMessage = 'ネットワークエラー: ' + err.message;
      } else if (err.response) {
        errorMessage = err.response.data.message || 'エラーが発生しました';
        if (err.response.status === 401) {
          router.push('/login');
        }
      } else {
        errorMessage = err.message;
      }
      throw new Error(errorMessage);
    });
},

  deleteSkillSheet: async (authUserId, sessionKey, careerItemsTrashCan, skillSheetTrashCan) => {
    config.url = baseUrl + '/api/skillSheet/delete';
    config.method = 'POST';
    config.data = { authInfo: { authUserId, sessionKey }, careerItemsTrashCan, skillSheetTrashCan };

    return axios.request(config)
      .then((res) => {
        return res
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },
};
